export const ROOT_PATH_TV = 'tv';

export const TvRoutes = {
    ROOT: {path: '', fullPath: `/${ROOT_PATH_TV}`},
}